import React from "react";
import type AcxMainTextField from "components/UI/AcxMainTextField";
import type { AcxMainTextFieldRef } from "components/UI/AcxMainTextField";
import theme from "Theme/AppTheme";
import CommentComposerBase from "./CommentComposerBase";

type ReplyComposerProps = {
    value: string;
    isSaving: boolean;
    inputRef: React.RefObject<AcxMainTextFieldRef>;
    onChange: (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => void;
    inputProps: React.ComponentProps<typeof AcxMainTextField>["inputProps"];
    onCancel: () => void;
    onSubmit: () => void;
    mentionDropdown: React.ReactNode;
};

const ReplyComposer = ({
    value,
    isSaving,
    inputRef,
    onChange,
    inputProps,
    onCancel,
    onSubmit,
    mentionDropdown,
}: ReplyComposerProps) => (
    <CommentComposerBase
        inputId="reply-comment-composer-text-input"
        placeholderText="Write a reply or @ mention someone"
        value={value}
        inputRef={inputRef}
        onChange={onChange}
        inputProps={inputProps}
        mentionDropdown={mentionDropdown}
        actionJustify="flex-end"
        onCancel={onCancel}
        onSubmit={onSubmit}
        primaryLabel={isSaving ? "Posting..." : "Post Reply"}
        secondaryLabel="Cancel"
        primaryButtonId="reply-comment"
        disablePrimary={!value.trim() || isSaving}
        disableSecondary={isSaving}
        containerBackground={theme.palette.gray[50]}
        inputBackground={theme.palette.white.main}
    />
);

export default ReplyComposer;
